import React from 'react';
import SidebarUnitDesktop from "components/sidebar/components/SidebarUnitDesktop";
import { GamepadIcon } from "assets/icons";

const JobbizGameDL = () => {
    return (
        <SidebarUnitDesktop 
            routeName={"Jobbiz Game"} 
            routeSidebar={"/jobbiz-game"}
            icon={GamepadIcon}
            text="Jobbiz Game"
            exactMatch={true}
        />
    );
};

export default JobbizGameDL;

